import authentication from "./userReducer";
import navigation from "./navigationReducer";

let reducer = { authentication,navigation };

export default reducer;
